<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="dark" (click)="modalGC.dismiss(undefined, 'cancel'); clearSelection()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Select Employee Installer</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <gc-search
    (criteriaChanged)="search($event)"
    (cleared)="searchCleared()"
    placeholder="Search Employee Name"
    [value]="criteria$ | push"
  ></gc-search>
  <gc-select-installer
    [multi]="false"
    [installers]="installers$ | push"
    [selected]="selected$ | push"
    [workOrder]="workOrder"
    (selectedChange)="selectionChanged($event)"
  ></gc-select-installer>
</ion-content>

<ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button
          data-cy="award-work-order-to-employee-modal"
          expand="block"
          color="gc-green"
          mode="ios"
          [disabled]="!(selected$ | push)?.length"
          (click)="publish()"
        >
          Assign to Employee
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
